import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-modal-leistung-name',
  templateUrl: './modal-leistung-name.component.html',
  styles: [
  ]
})
export class ModalLeistungNameComponent extends ExcTranslation implements OnInit {
  @Input() data: {
    headerText: string;
    caption: string;
    buttonText: string;
    name: string;
  } = {headerText: '', caption: '', buttonText: '', name: ''};

  name = '';

  constructor(
    public modal: ExgModalService
  ) {
    super();
  }

  ngOnInit(): void {
    this.name = this.data.name || '';
  }

  valid(): boolean {
    return this.name.trim().length > 0;
  }

  save(): void {
    if (!this.valid()) {
      return;
    }
    this.modal.action({name: this.name});
    this.modal.close();
  }

  cancel(): void {
    this.modal.close();
  }

}
